import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyMobileBar from "@/components/layout/StickyMobileBar";
import StormBanner from "@/components/layout/StormBanner";
import DryRunRibbon from "@/components/layout/DryRunRibbon";
import PromoBar from "@/components/layout/PromoBar";
import SeasonalGuideBanner from "@/components/layout/SeasonalGuideBanner";
import AssistantWidget from "@/components/chat/AssistantWidget";

export default function PublicLayout() {
    const location = useLocation();
    useEffect(() => {
        // Scroll to top on route change for cleaner navigation
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname]);

    // Mark the body as a public page so the GHL chat widget is allowed to
    // show (default-hidden in index.css; opted in only here). On unmount we
    // clear the attribute so admin/customer routes never see it.
    useEffect(() => {
        document.body.setAttribute("data-section", "public");
        return () => {
            document.body.removeAttribute("data-section");
        };
    }, []);

    return (
        <div className="App has-sticky-bar">
            <a href="#main-content" className="skip-link">Skip to main content</a>
            <DryRunRibbon />
            <PromoBar />
            <StormBanner />
            <Header />
            <SeasonalGuideBanner />
            <main id="main-content">
                <Outlet />
            </main>
            <Footer />
            <AssistantWidget />
            <StickyMobileBar />
        </div>
    );
}
